<template>
    <div class="unit-test">
        <div>
            <div class="row">
                <div class="col-6">
                    <ApexLineChart
                        :Data="data.data_1"
                        :Option="{
                            title: '平均交期',
                            subtitle: ''
                        }"
                    />
                </div>
                <div class="col-6">
                    <ApexDataBarChart
                        :Data="data.data_2"
                        :Option="{
                            title: '校正差異四周',
                        }"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <ApexDataBarChart
                        :Data="data.data_3"
                        :Option="{
                            title: '校正訊息筆數'
                        }"
                    />
                </div>
                <div class="col-6">
                    <ApexHeatMapChart
                        :Data="data.data_4"
                        :Option="{
                            title: '校正錯誤統計'
                        }"
                    />
                </div>
            </div>
            <div class="row report">
                <div class="report-title">
                    校正報表(8天)
                </div>
                <div class="report-body">
                    <div v-for="item, i in report_title" :key="i">
                        <div class="report-body-column">
                            {{item.name}}
                        </div>
                        <div class="report-body-row">
                            {{item.value}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import api from './api.js'
import { BButton, BRow, BCol, BFormInput, BFormGroup, BCard } from 'bootstrap-vue'
// import ApexLineChart from '@/views/charts-and-maps/charts/apex-chart/ApexLineChart.vue'
import ApexLineChart from './components/ApexLineChart.vue'
import ApexDataBarChart from './components/ApexDataBarChart.vue'
import ApexHeatMapChart from './components/ApexHeatMapChart.vue'
import data from './data.json'
export default {
    name: 'UnitTest',
    components: {
        BButton,
        BRow,
        BCol,
        BCard,
        BFormInput,
        BFormGroup,
        ApexLineChart, // 折線圖
        ApexDataBarChart, // 直線圖
        ApexHeatMapChart, // 點陣圖
    },
    setup(props, ctx) {

        let report_title = data.data_5
        let report_style = {
            'cell-width': Math.floor(100 / report_title) + '%',
        }


        return {
            report_title,
            report_style,
            data,
        }
    }
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
$report-style-color: #eeeeee;
.report {
    background: white;
    width: 100%;
    height: 30vh;
    border-radius: 10px;
    border: 1px $report-style-color solid;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 5px 5px $report-style-color;
    .report-title {
        height: 50px;
        font-size: 18px;
        padding: 10px;
        font-family: "Montserrat", Helvetica, Arial, serif;
    }
    .report-body {
        display: flex;
        height: calc(100% - 50px);
        div {
            flex: 1 1 0px;
            text-align: center;
            div {
                border: 1px $report-style-color solid;
            }
        }
        .report-body-row {
            height: 80%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}
</style>
